import { render, staticRenderFns } from "./news_topic_all.vue?vue&type=template&id=54bbeb61&scoped=true&"
import script from "./news_topic_all.vue?vue&type=script&lang=js&"
export * from "./news_topic_all.vue?vue&type=script&lang=js&"
import style0 from "./news_topic_all.vue?vue&type=style&index=0&id=54bbeb61&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bbeb61",
  null
  
)

export default component.exports